import * as React from "react";
import PropTypes from "prop-types";
import SwipeableViews from "react-swipeable-views";
import { useTheme } from "@mui/material/styles";
import AppBar from "@mui/material/AppBar";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import mission from "../../../assets/technical/img_1.jpg";
import vision from "../../../assets/farm/img_15.jpg";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`full-width-tabpanel-${index}`}
      aria-labelledby={`full-width-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography variant="body1">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `full-width-tab-${index}`,
    "aria-controls": `full-width-tabpanel-${index}`,
  };
}

const Intro = () => {
  const theme = useTheme();
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const handleChangeIndex = (index) => {
    setValue(index);
  };
  return (
    <Box marginTop={{ xs: "25%", sm: "10%" }}>
      <Typography
        variant="h3"
        color="#00AEEF"
        fontWeight={900}
        paddingBottom={"3%"}
        textAlign={"left"}
      >
        About Us
      </Typography>
      <Box
        width={"100%"}
        display={"flex"}
        justifyContent={"space-between"}
        alignItems={"flex-start"}
        flexWrap={"wrap"}
      >
        <Box
          width={{ xs: "100%", sm: "42%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          paddingRight={{ xs: "0%", sm: "2%" }}
        >
          <Typography
            variant={"body1"}
            fontWeight={400}
            textAlign={"left"}
            color={"#4f4f4f"}
            lineHeight={"1.625em"}
          >
            Aquatic Hub Afrique Network is an offshoot of Fish Shoal Nigeria.
            Fish Shoal Nigeria (Trading Arm of Aquatic Hub Afrique) was founded
            in 2006 and incorporated in 2011, solely to address the production
            of good quality fish in Nigeria. The huge potential in the
            Aquaculture Industry over the years has increased but the vehicles
            to deliver the desired growth are missing due to lack of skilled key
            players (staff) responsible for the production of fish. On this
            premise, Fish Shoal Nigeria decided to establish a pan-African
            Aquaculture training centre in February, 2017.
          </Typography>
        </Box>
        <Box
          width={{ xs: "100%", sm: "55%" }}
          marginLeft={{ xs: "0%", sm: "0%" }}
          marginTop={{ xs: "10%", sm: "0%" }}
          padding={{ xs: "1%", sm: "2%" }}
          bgcolor={"#F4F9FF"}
        >
          <Box
            sx={{
              bgcolor: "background.paper",
              width: 600,
            }}
          >
            <AppBar
              position="static"
              sx={{
                bgcolor: "#000",
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                indicatorColor="primary"
                textColor="inherit"
                variant="fullWidth"
                aria-label="full width tabs example"
                sx={{
                  bgcolor: "#000",
                  width: "80%",
                }}
              >
                <Tab
                  label="Our Mission"
                  {...a11yProps(0)}
                  sx={{
                    fontWeight: 700,
                  }}
                />

                <Tab
                  label="Our Vision"
                  {...a11yProps(1)}
                  sx={{
                    fontWeight: 700,
                  }}
                />
                <Tab
                  label="Our Goals"
                  {...a11yProps(2)}
                  sx={{
                    fontWeight: 700,
                  }}
                />
              </Tabs>
            </AppBar>
            <SwipeableViews
              axis={theme.direction === "rtl" ? "x-reverse" : "x"}
              index={value}
              onChangeIndex={handleChangeIndex}
            >
              <TabPanel value={value} index={0} dir={theme.direction}>
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  flexWrap={"wrap"}
                >
                  <Box
                    width={{ xs: "100%", sm: "35%" }}
                    marginLeft={{ xs: "0%", sm: "0%" }}
                    marginTop={{ xs: "10%", sm: "0%" }}
                    display={{ xs: "none", sm: "block" }}
                  >
                    <Box
                      component="img"
                      height={{ xs: "27vh", sm: "15vh" }}
                      width={{ xs: "100%", sm: "100%" }}
                      src={mission}
                      alt={"mission-img"}
                      sx={{
                        objectFit: "cover",
                        "&:hover": {
                          opacity: 0.5,
                        },
                      }}
                    />
                  </Box>
                  <Box width={{ xs: "100%", sm: "65%" }}>
                    <Typography
                      variant={"body1"}
                      color={"#4f4f4f"}
                      paddingTop={"1%"}
                      paddingLeft={{ xs: "2%", sm: "8%" }}
                    >
                      Our mission is to produce high-quality, affordable fish
                      stocks and ensure that no African is deprived of access to
                      fish protein, as long as there are water resources in
                      their environment.
                    </Typography>
                  </Box>
                </Box>
              </TabPanel>
              <TabPanel value={value} index={1} dir={theme.direction}>
                <Box
                  width={"100%"}
                  display={"flex"}
                  justifyContent={"space-between"}
                  alignItems={"flex-start"}
                  flexWrap={"wrap"}
                >
                  <Box
                    width={{ xs: "100%", sm: "35%" }}
                    marginLeft={{ xs: "0%", sm: "0%" }}
                    marginTop={{ xs: "10%", sm: "0%" }}
                    display={{ xs: "none", sm: "block" }}
                  >
                    <Box
                      component="img"
                      height={{ xs: "17vh", sm: "15vh" }}
                      width={{ xs: "100%", sm: "100%" }}
                      src={vision}
                      alt={"vision-img"}
                      sx={{
                        objectFit: "cover",
                        "&:hover": {
                          opacity: 0.5,
                        },
                      }}
                    />
                  </Box>
                  <Box width={{ xs: "100%", sm: "65%" }}>
                    <Typography
                      variant={"body1"}
                      color={"#4f4f4f"}
                      paddingTop={"1%"}
                      paddingLeft={{ xs: "2%", sm: "8%" }}
                    >
                      Our vision is to transform Africa’s blue food systems
                      through a sustainable, climate-resilient network across
                      aquaculture and fisheries. We aim to ensure affordable,
                      high-quality fish protein for all, supporting food
                      security, biodiversity, and resilient livelihoods within a
                      responsibly managed blue economy.
                    </Typography>
                  </Box>
                </Box>
              </TabPanel>
              <TabPanel value={value} index={2} dir={theme.direction}>
                <Typography variant={"body1"} color={"#4f4f4f"}>
                  {" "}
                  <Typography
                    component={"span"}
                    color="#00AEEF"
                    fontWeight={500}
                    variant={"h5"}
                  >
                    &#10052;{" "}
                  </Typography>{" "}
                  Sustainable Aquaculture and Fisheries Management and Zero
                  Hunger
                </Typography>
                <Typography
                  variant={"body1"}
                  color={"#4f4f4f"}
                  paddingTop={"1%"}
                >
                  {" "}
                  <Typography
                    component={"span"}
                    color="#00AEEF"
                    fontWeight={500}
                    variant={"h5"}
                  >
                    &#10052;{" "}
                  </Typography>{" "}
                  Employment Generation
                </Typography>
                <Typography
                  variant={"body1"}
                  color={"#4f4f4f"}
                  paddingTop={"1%"}
                >
                  {" "}
                  <Typography
                    component={"span"}
                    color="#00AEEF"
                    fontWeight={500}
                    variant={"h5"}
                  >
                    &#10052;{" "}
                  </Typography>{" "}
                  Diversity, Inclusion and Skill Gap
                </Typography>
                <Typography
                  variant={"body1"}
                  color={"#4f4f4f"}
                  paddingTop={"1%"}
                >
                  {" "}
                  <Typography
                    component={"span"}
                    color="#00AEEF"
                    fontWeight={500}
                    variant={"h5"}
                  >
                    &#10052;{" "}
                  </Typography>{" "}
                  Technology, Innovation and Research
                </Typography>
                <Typography
                  variant={"body1"}
                  color={"#4f4f4f"}
                  paddingTop={"1%"}
                >
                  {" "}
                  <Typography
                    component={"span"}
                    color="#00AEEF"
                    fontWeight={500}
                    variant={"h5"}
                  >
                    &#10052;{" "}
                  </Typography>{" "}
                  Livelihood Improvement
                </Typography>
              </TabPanel>
            </SwipeableViews>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Intro;
